import React, { useEffect } from 'react';
import AdminDashboard from '@/components/admin/AdminDashboard';

const Admin: React.FC = () => {
  useEffect(() => {
    console.log('🔧 Admin page mounted');
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <AdminDashboard />
    </div>
  );
};

export default Admin;
